import { OrderItemServicesProperties } from './order-item-services-properties';

export interface OrderItemService {
  serviceId: number;
  serviceCode: string;
  serviceName: string;
  serviceType?: {
    serviceTypeId: number
    serviceTypeCode: string
    serviceTypeDesc: string
  };
  orderServiceCode: string;
  properties: OrderItemServicesProperties[];
}
